export const MALE = '197';
export const FEMALE = '198';
export const PREFER_NOT_TO_SAY = '207';
